import s from './LoadingBar.module.css'

type LoadingBarProps = {
  width?: number
  height?: number
  borderRadius?: number
}

export const LoadingBar: React.FC<LoadingBarProps> = ({
  width,
  height,
  borderRadius,
}) => {
  return (
    <div
      className={s.wrapper}
      style={{
        ...(width && { width: `${width}px` }),
        ...(height && { height: `${height}px` }),
        ...(borderRadius && { borderRadius: `${borderRadius}px` }),
      }}
    />
  )
}
